import { createComponent } from '@carvana/merch-components';

const Pulser = createComponent('div', {
  className: 'animate-pulse rounded-md bg-background-skeleton'
});

export const SkeletonTextSmall = createComponent(Pulser, {
  className: 'h-16'
});

export const SkeletonTextMedium = createComponent(Pulser, {
  className: 'h-20'
});
